import config from '../../../../config/config';
import React from 'react';

import './ConvertIRAActionBar.scss';

const ConvertIRAActionBar = () => {
  return (
    <a
      href={`${config.url}/usis/transactions/roth-conversion`}
      className="convert-ira-action-bar"
    >
      To convert your eligible IRA to a new Roth IRA, use our Roth IRA
      Conversion Tool.
    </a>
  );
};

export default ConvertIRAActionBar;
